export const colorInterpolate = (
  colorStart: string | null,
  colorEnd: string | null,
  factor?: number
) => {
  if (colorStart && colorEnd && factor !== undefined) {
    const colorStartRGB = isRgba(colorStart)
      ? rgba(colorStart)
      : hexToRgb(colorStart)
    const colorEndRGB = isRgba(colorEnd) ? rgba(colorEnd) : hexToRgb(colorEnd)

    const _factor = Math.min(1, factor)

    // Линейная интерполяция между компонентами R, G и B
    const red = Math.round(
      colorStartRGB.red + (colorEndRGB.red - colorStartRGB.red) * _factor
    )
    const green = Math.round(
      colorStartRGB.green + (colorEndRGB.green - colorStartRGB.green) * _factor
    )
    const blue = Math.round(
      colorStartRGB.blue + (colorEndRGB.blue - colorStartRGB.blue) * _factor
    )

    if (colorEndRGB.alpha !== undefined && factor >= 0) {
      return `rgb(${red}, ${green}, ${blue}, ${colorEndRGB.alpha})`
    }

    return `rgb(${red}, ${green}, ${blue})`
  }

  return 'inherit'
}

const hexToRgb = (
  hex: string
): {
  red: number
  green: number
  blue: number
  alpha?: number
} => {
  // Убираем #
  hex = hex.replace(/^#/, '')

  if (hex.length === 8) {
    const red = parseInt(hex.slice(0, 2), 16)
    const green = parseInt(hex.slice(2, 4), 16)
    const blue = parseInt(hex.slice(4, 6), 16)
    const alpha = parseInt(hex.slice(6, 8), 16) / 255

    return { red, green, blue, alpha }
  }

  // Разбиваем HEX на компоненты
  const bigint = parseInt(hex, 16)
  const red = (bigint >> 16) & 255
  const green = (bigint >> 8) & 255
  const blue = bigint & 255

  return { red, green, blue }
}

const rgbaRegex = /rgba\((\d+), (\d+), (\d+), (\d+\.?\d*)\)/
// const rgbRegex = /rgb\((\d+), (\d+), (\d+)\)/;

const isRgba = (color: string) => {
  return rgbaRegex.test(color)
}

const rgba = (
  color: string
): {
  red: number
  green: number
  blue: number
  alpha?: number
} => {
  const match = color.match(rgbaRegex)

  return {
    red: parseInt(match![1]),
    green: parseInt(match![2]),
    blue: parseInt(match![3]),
    alpha: parseFloat(match![4]),
  }
}
